export default function getSelectionInstance(
    selectedText: string,
    element: HTMLElement,
    selectionRange?: Range
): number {
    // Make sure selection is within the mail message element
    if (selectionRange.intersectsNode(element)) {
        // Get text preceding the selection
        let rangeBeforeHighlight = document.createRange();
        rangeBeforeHighlight.setStartBefore(element);
        rangeBeforeHighlight.setEnd(selectionRange.startContainer, selectionRange.startOffset);

        const allTextBeforeHighlight = rangeBeforeHighlight.toString();

        // Calculate the number of instances of the selected text within the preceding text
        const selectedTextRegex = new RegExp(selectedText, 'gi');
        const selectionInstancesInAllTextBeforeHighlight = allTextBeforeHighlight.match(
            selectedTextRegex
        );

        // The selected text follows the proceding text, so its instance number
        // is the number of instances within the preceding text
        // The instance number is 0 when the array containing all the instances is null or empty.
        return selectionInstancesInAllTextBeforeHighlight
            ? selectionInstancesInAllTextBeforeHighlight.length
            : 0;
    }

    // Return -1 if the selection is not in the mail message element
    return -1;
}
